export default __webpack_public_path__ + "static/media/white_dragon.46a29d59.png";